import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ToiletCleaner from '../LandingPage/Controler/ToiletCleaner';
import FloorCleaner from '../LandingPage/Controler/FloorCleaner';
import SurfaceCleaner from '../LandingPage/Controler/SurfaceCleaner';
import HandWash from '../LandingPage/Controler/HandWash';
import MegaSaverPack from '../LandingPage/Controler/MegaSaverPack';
import Phenyl from '../LandingPage/Controler/Phenyl';
// map URL slug → component
const categoryComponents = {
  "toilet-cleaner": <ToiletCleaner title="Toilet Cleaner" count={true} showSlider={false} />,
  "floor-cleaner":   <FloorCleaner title="Floor Cleaner" count={true} showSlider={false} />,
  "surface-cleaner": <SurfaceCleaner title="Surface Cleaner" count={true} showSlider={false} />,
  "hand-wash":       <HandWash title="Hand Wash" count={true} showSlider={false} />,
  "dish-wash":       <MegaSaverPack title="Dish Wash" showSlider={false} />,
  "phenyl":       <Phenyl title="Phenyl" count={true} showSlider={false}/>,
};

function ProductPage() {
  const { subCategory } = useParams(); // ← reads from URL

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [subCategory]);

  const Component = categoryComponents[subCategory];

  return (
    <div className="w-full flex flex-col justify-center items-center bg-[#d9d9d9]">
      <div className="w-full flex flex-col justify-center items-center p-[5px] bg-[#fff]">
        {Component
          ? Component
          : (
            <div className="flex flex-col items-center justify-center py-24 text-center">
              <p className="text-2xl font-bold text-gray-700 mb-2">Category not found</p>
              <p className="text-gray-400 text-sm">
                No products found for <b>{subCategory}</b>
              </p>
            </div>
          )
        }
      </div>
    </div>
  );
}

export default ProductPage;